// EP house-system product policy (SkySpeaks decision, not astro's): known
// and approximate birth times always use Equal Houses; unknown birth time
// defaults to Solar Houses, with an explicit visitor opt-out to No Houses.
// astro itself never assumes this -- it accepts house_system as an
// explicit, optional request field and does nothing by default.

export const HOUSE_SYSTEM_CHOICE = {
  SOLAR: 'solar',
  NO_HOUSES: 'no_houses',
};

const VALID_CHOICES = new Set(Object.values(HOUSE_SYSTEM_CHOICE));

export function normalizeHouseSystemChoice(value) {
  return VALID_CHOICES.has(value) ? value : HOUSE_SYSTEM_CHOICE.SOLAR;
}

/**
 * Resolve the astro `house_system` request value ("equal" | "solar" | null)
 * from birth-time accuracy and (when accuracy is "unknown") the visitor's
 * explicit house-system choice.
 */
export function resolveHouseSystem(birthTimeAccuracy, houseSystemChoice) {
  if (birthTimeAccuracy === 'known' || birthTimeAccuracy === 'approximate') {
    return 'equal';
  }
  return normalizeHouseSystemChoice(houseSystemChoice) === HOUSE_SYSTEM_CHOICE.NO_HOUSES
    ? null
    : 'solar';
}

/**
 * Map an already-resolved astro house_system value (as returned on a
 * previously-calculated chart) back to the unknown-time UI choice, so
 * returning to edit birth details pre-fills the same choice rather than
 * silently reverting to the default.
 */
export function houseSystemChoiceFromResolved(houseSystem) {
  if (houseSystem === null) {
    // A chart was already calculated with no house system -- for an
    // unknown birth time (the only case house_system can be null after a
    // real calculation), that only happens when the visitor explicitly
    // chose No Houses.
    return HOUSE_SYSTEM_CHOICE.NO_HOUSES;
  }
  // undefined (no chart yet) or "equal"/"solar": no meaningful prior
  // unknown-time choice to restore -- default to Solar Houses.
  return HOUSE_SYSTEM_CHOICE.SOLAR;
}
